/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CampaignControllerDtoAppDetailAppDetailDataList model module.
 * @module model/CampaignControllerDtoAppDetailAppDetailDataList
 * @version 1.0
 */
class CampaignControllerDtoAppDetailAppDetailDataList {
    /**
     * Constructs a new <code>CampaignControllerDtoAppDetailAppDetailDataList</code>.
     * @alias module:model/CampaignControllerDtoAppDetailAppDetailDataList
     */
    constructor() { 
        
        CampaignControllerDtoAppDetailAppDetailDataList.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CampaignControllerDtoAppDetailAppDetailDataList</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CampaignControllerDtoAppDetailAppDetailDataList} obj Optional instance to populate.
     * @return {module:model/CampaignControllerDtoAppDetailAppDetailDataList} The populated <code>CampaignControllerDtoAppDetailAppDetailDataList</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CampaignControllerDtoAppDetailAppDetailDataList();

            if (data.hasOwnProperty('campaignNo')) {
                obj['campaignNo'] = ApiClient.convertToType(data['campaignNo'], 'Number');
            }
            if (data.hasOwnProperty('campaignTitle')) {
                obj['campaignTitle'] = ApiClient.convertToType(data['campaignTitle'], 'String');
            }
            if (data.hasOwnProperty('campaignType')) {
                obj['campaignType'] = ApiClient.convertToType(data['campaignType'], 'Number');
            }
            if (data.hasOwnProperty('startAt')) {
                obj['startAt'] = ApiClient.convertToType(data['startAt'], 'Date');
            }
            if (data.hasOwnProperty('endAt')) {
                obj['endAt'] = ApiClient.convertToType(data['endAt'], 'Date');
            }
            if (data.hasOwnProperty('isLock')) {
                obj['isLock'] = ApiClient.convertToType(data['isLock'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CampaignControllerDtoAppDetailAppDetailDataList</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CampaignControllerDtoAppDetailAppDetailDataList</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['campaignTitle'] && !(typeof data['campaignTitle'] === 'string' || data['campaignTitle'] instanceof String)) {
            throw new Error("Expected the field `campaignTitle` to be a primitive type in the JSON string but got " + data['campaignTitle']);
        }

        return true;
    }


}



/**
 * @member {Number} campaignNo
 */
CampaignControllerDtoAppDetailAppDetailDataList.prototype['campaignNo'] = undefined;

/**
 * @member {String} campaignTitle
 */
CampaignControllerDtoAppDetailAppDetailDataList.prototype['campaignTitle'] = undefined;

/**
 * @member {Number} campaignType
 */
CampaignControllerDtoAppDetailAppDetailDataList.prototype['campaignType'] = undefined;

/**
 * @member {Date} startAt
 */
CampaignControllerDtoAppDetailAppDetailDataList.prototype['startAt'] = undefined;

/**
 * @member {Date} endAt
 */
CampaignControllerDtoAppDetailAppDetailDataList.prototype['endAt'] = undefined;

/**
 * @member {Boolean} isLock
 */
CampaignControllerDtoAppDetailAppDetailDataList.prototype['isLock'] = undefined;






export default CampaignControllerDtoAppDetailAppDetailDataList;

